function flatten(array) {
  return array.reduce(
    (flat, toFlatten) =>
      flat.concat(Array.isArray(toFlatten) ? flatten(toFlatten) : toFlatten),
    []
  );
}

export function getValuesForKey(key, item) {
  const keys = key.split(".");
  let results = [item];
  keys.forEach((_key) => {
    const tmp = [];
    results.forEach((result) => {
      if (result) {
        if (result instanceof Array) {
          const index = parseInt(_key, 10);
          if (!Number.isNaN(index)) {
            tmp.push(result[index]);
          }
          result.forEach((res) => {
            tmp.push(res[_key]);
          });
        } else if (result && typeof result.get === "function") {
          tmp.push(result.get(_key));
        } else {
          tmp.push(result[_key]);
        }
      }
    });
    results = tmp;
  });

  // Support arrays and Immutable lists.
  results = results.map((r) => (r && r.push && r.toArray ? r.toArray() : r));
  results = flatten(results);

  return results.filter((r) => typeof r === "string" || typeof r === "number");
}

function searchStrings(strings, term, { exactMatch } = {}) {
  strings = strings.map((e) => e.toString());

  try {
    return strings.some((value) => {
      try {
        value = value.toLowerCase();
        const indexOfTerm = value.indexOf(term.toLowerCase());
        const valueMatchesTerm = indexOfTerm !== -1;

        if (exactMatch) {
          const valueStartsWithTerm =
            indexOfTerm === 0 || value[indexOfTerm - 1] === " ";

          if (valueMatchesTerm && valueStartsWithTerm) {
            return true;
          }
        } else if (valueMatchesTerm) {
          return true;
        }

        return false;
      } catch (e) {
        return false;
      }
    });
  } catch (e) {
    return false;
  }
}

export function createFilter(term, keys, options = {}) {
  return (item) => {
    if (term === "") {
      return true;
    }

    const terms = term.split(" ");

    if (!keys) {
      return terms.every((termItem) =>
        searchStrings([item], termItem, options)
      );
    }

    if (typeof keys === "string") {
      keys = [keys];
    }

    return terms.every((termItem) => {
      // allow search in specific fields with the syntax `field:search`
      let currentKeys;
      if (termItem.indexOf(":") !== -1) {
        const searchedField = termItem.split(":")[0];
        // eslint-disable-next-line prefer-destructuring
        term = termItem.split(":")[1];
        currentKeys = keys.filter(
          (key) => key.toLowerCase().indexOf(searchedField) > -1
        );
      } else {
        currentKeys = keys;
      }

      return currentKeys.some((key) => {
        const values = getValuesForKey(key, item);
        return searchStrings(values, term, options);
      });
    });
  };
}
